<template lang="pug">
.sell-record-detail.d-flex.flex-column.h-100.scrollable
  .custom-header.d-flex.sticky-top
    CustomTab.flex-fill(
      :tabItems='tabItems'
      :tabItemsOptions='tabItemsOptions'
      v-model='selectedTab'
    )
    button.transparent-button(@click='$emit(`closeButtonClicked`)')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

  template(v-if='selectedTab === `RECORD_DETAIL`')
    Detail(
      :customer='customer'
      :sellRecord='sellRecord'
    )

  template(v-else-if='selectedTab === `RECORD_HISTORY`')
    History(
      :orderId='sellRecord.id'
      v-model='sellRecord.updated'
    )

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

import Detail from './tabs/Detail.vue';
import History from './tabs/History.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    sellRecord: {
      default: () => ({}),
    },
  },
  watch: {
    sellRecord: {
      handler() {
        this.onSellRecordUpdated();
      },
      deep: true,
    },
  },
  mounted() {
    this.onSellRecordUpdated();
  },
  methods: {
    onSellRecordUpdated() {
      // const res = this.$api.order.getWithId(this.sellRecord.id);
      // console.log(res);
      this.tabItemsOptions.RECORD_HISTORY = {
        showNotificationDot: this.sellRecord.updated === true,
      };
    },
  },
  data: () => ({
    tabItems: {
      RECORD_DETAIL: 'รายละเอียดรายการ',
      RECORD_HISTORY: 'ประวัติการทำรายการ',
    },
    tabItemsOptions: {},
    selectedTab: 'RECORD_DETAIL',
  }),
  components: {
    CustomerCompactDetailHeader,

    Detail,
    History,
  },
};
</script>

<style lang="scss">
// .sell-record-detail {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
